import { combineReducers } from "redux";
import {
  BookFont,
  DisplayMode,
  NO_FONT_SIZE,
  NO_LINE_HEIGHT,
  NO_MARGIN,
  ReaderView,
} from "./utils";
import ViewerMethod from "../../../core/ViewerMethod";
import { getStartActionName } from "../../../core/make-action";
import { persistReducer } from "../../../core/persistReducer";

function makeEnhancedFormattingReducer(initialValue, method) {
  return function (state = { value: initialValue, enabled: false }, action) {
    switch (action.type) {
      case getStartActionName(method):
        return {
          value: action.apiCallArgs[0],
          enabled: true,
        };
      case getStartActionName(ViewerMethod.REMOVE_ENHANCED_FORMATTING_CSS):
        return {
          value: initialValue,
          enabled: false,
        };
      default:
        return state;
    }
  };
}

function enabled(state = false, action) {
  switch (action.type) {
    case getStartActionName(ViewerMethod.ADD_ENHANCED_FORMATTING_CSS):
      return true;
    case getStartActionName(ViewerMethod.REMOVE_ENHANCED_FORMATTING_CSS):
      return false;
    default:
      return state;
  }
}

const settingsReducer = combineReducers({
  enabled,
  readerView: makeEnhancedFormattingReducer(
    ReaderView.DEFAULT,
    ViewerMethod.SET_READER_VIEW
  ),
  fontFamily: makeEnhancedFormattingReducer(
    BookFont.DEFAULT,
    ViewerMethod.SET_FONT_FAMILY
  ),
  lineHeight: makeEnhancedFormattingReducer(
    NO_LINE_HEIGHT,
    ViewerMethod.SET_LINE_HEIGHT
  ),
  displayMode: makeEnhancedFormattingReducer(
    DisplayMode.NONE,
    ViewerMethod.SET_DISPLAY_MODE
  ),
  pageMargin: makeEnhancedFormattingReducer(
    NO_MARGIN,
    ViewerMethod.SET_PAGE_MARGIN
  ),
  fontSize: makeEnhancedFormattingReducer(
    NO_FONT_SIZE,
    ViewerMethod.SET_TEXT_SIZE
  ),
});

export default persistReducer("content-controls-enhanced", settingsReducer, {
  stateToStorage: (state) => {
    if (!state.enabled) {
      return undefined;
    }
    return state;
  },
  byBook: true,
});
